module.exports = __webpack_public_path__ + "img/Group 26583@2x.43ac781d.png";